import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as Section from "@repoflow/components/section";
import PointPublicSchema from "@common/schema/point/public";
import * as HomeRoute from "./home";

// Read-only and single-page: the dashboard summarises what lives under /point,
// so there is nothing here to create, edit or address individually.
//
// The point schema alone, since the usage rows moved onto /point/:pointId on
// 2026-08-11 — nothing on this screen renders a row of any declared type now.
// It is kept because Section.Provider is what supplies `base`/`basepath` to the
// route below, not for anything it resolves a widget for.
const LocalProvider = ({ match: { params }, children: Children }) => {
  const base = `/dashboard`;
  const basepath = `/dashboard`;

  return (
    <Section.Provider
      schema={PointPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/`} component={HomeRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={base}>Dashboard</Link>
          </BreadcrumbItem>
          <Switch>
            <Route path={`${basepath}/`} component={HomeRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
